import { defineRecipe } from "@chakra-ui/react";

export const breadcrumbRecipe = defineRecipe({
  base: {
    color: "mainColor.100",
    fontSize: "xs",
    transition: "all .5s",
    fontWeight: "bold",
    fontFamily: "body",

    container: {
      fontSize: "xs",
      transition: "all .5s",
      fontWeight: "bold",
      fontFamily: "body",
    },
    link: {
      transition: "all .5s",
      color: "mainText.100",
      _hover: {
        textDecoration: "none",
        color: "purpulС.200",
        transition: "all .5s",
      },
    },
    separator: {
      color: "mainText.100",
    },
  },
  variants: {
    visual: {
      isCurrentPage: {
        color: "mainText.200",
        _hover: {
          textDecoration: "none",
          color: "mainText.200",
        },
      },
    },
  },
  defaultVariants: {
    visual: "isCurrentPage",
  },
});
